// extracted by mini-css-extract-plugin
export default {"container":"style_container__jrf3j","header":"style_header__N1RIA"};